import type {
  CreateFaceScanKeystoreInput,
  DataResponse,
  FaceScanKeystore,
  FaceScanKeystoreListQuery,
  FaceScanKeystoreSummary,
  FaceScanLookupResult,
  PaginatedResponse,
  UpdateFaceScanKeystoreInput,
} from '@pms/shared';
import { api } from '@/lib/api';

// PMS backend proxy for the Rate API keystores; it calls the Rate API without any pass key.
const BASE = '/face-scan-keystores';

function keystorePath(keystoreId: string): string {
  return `${BASE}/${encodeURIComponent(keystoreId)}`;
}

export const faceScanKeystoresService = {
  async list(query: Partial<FaceScanKeystoreListQuery> = {}): Promise<PaginatedResponse<FaceScanKeystore>> {
    const res = await api.get<PaginatedResponse<FaceScanKeystore>>(BASE, { params: query });
    return res.data;
  },

  async summary(): Promise<FaceScanKeystoreSummary> {
    const res = await api.get<DataResponse<FaceScanKeystoreSummary>>(`${BASE}/summary`);
    return res.data.data;
  },

  async get(keystoreId: string): Promise<FaceScanKeystore> {
    const res = await api.get<DataResponse<FaceScanKeystore>>(keystorePath(keystoreId));
    return res.data.data;
  },

  async create(input: CreateFaceScanKeystoreInput): Promise<FaceScanKeystore> {
    const res = await api.post<DataResponse<FaceScanKeystore>>(BASE, input);
    return res.data.data;
  },

  async update(keystoreId: string, input: UpdateFaceScanKeystoreInput): Promise<FaceScanKeystore> {
    const res = await api.patch<DataResponse<FaceScanKeystore>>(keystorePath(keystoreId), input);
    return res.data.data;
  },

  async remove(keystoreId: string): Promise<void> {
    await api.delete(keystorePath(keystoreId));
  },

  async lookup(keystoreId: string): Promise<FaceScanLookupResult> {
    const res = await api.post<DataResponse<FaceScanLookupResult>>(`${keystorePath(keystoreId)}/lookup`);
    return res.data.data;
  },
};
